import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';
import { Integration } from '../../common/types';
import IntegrationDetailsPanelController from '../controller/IntegrationDetailsPanelController';

export default class IntegrationDetailsPanelComponent extends BaseWebComponentElement {
  integration: Integration;

  constructor() {
    super();

    this.initialSetup({
      controllerConstructor: IntegrationDetailsPanelController,
    });
  }
}
